import { useEffect, useState } from "react";
import DUMMY_DATA from "../../dummyData.json";
import Product from "./Product";

/* 到時候後端寫批次fetch資料，我再透過類別查看總數量去計算總共幾頁 */
/* 根據尺寸大小計算呈現數量 */

const ProductPagination = () => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: "0px" });
  }, []);
  return (
    <div>
      {DUMMY_DATA.length > 0 ? (
        <>
          <Product
            data={DUMMY_DATA}
            title="Products"
            pageLimit={5}
            dataLimit={10}
          />
        </>
      ) : (
        <h1>還沒有任何產品😞</h1>
      )}
    </div>
  );
};

export default ProductPagination;
